import { getCookie } from './cookies'

export const getCountryCode = () => {
  return (
    getCountryCodeFromCookie() ||
    getCountryCodeFromUID()
  )
}

const getCountryCodeFromCookie = () => {
  const countryCodeCookie = getCookie('country_code')
  // The cookie might be set to the string "undefined"
  if (!countryCodeCookie || countryCodeCookie === 'undefined') {
    return undefined
  }
  return countryCodeCookie.toUpperCase()
}

const getCountryCodeFromUID = () => {
  const uidCountryCode = getCookie('uid')?.slice(0, 2)?.toUpperCase()
  // Anonymous users will have a country code of XX in the UID, we don't want to use this
  return uidCountryCode === 'XX' ? undefined : uidCountryCode
}
